import React from 'react';

import { PREVIEW_2_URL } from "utils/constants";


import "./Previews.css";

export default function Previews({
	creatives = [],
	sourceVersion = "default",
	showFooter = false,
}) {
	let idList = creatives?.map(v => v.id).join(",")
		, url = `${PREVIEW_2_URL}/basic/${idList}?selectedVersion=${sourceVersion}&showFooter=${showFooter}`;

	return (
		<div className="gen-ai-source-previews">
			<iframe className="cypress-gen-ai-source-previews source-previews" src={url} />
		</div>
	);
}

Previews.displayName = "Previews";
